module.exports = __webpack_public_path__ + "img/Sfondo_Urbano.595377b6.jpg";